import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useToast } from "@/hooks/use-toast";
import { CLINIC } from "@/constants/testIds";

/** Card de Ajustes: mensaje sugerido al contactar por WhatsApp desde Seguimiento. */
export default function FollowUpMessageSettingsCard({ clinic, onUpdated }) {
  const [template, setTemplate] = useState(clinic.followup_whatsapp_template || "");
  const [saving, setSaving] = useState(false);
  const { toast } = useToast();

  const handleSave = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/clinic", { followup_whatsapp_template: template });
      onUpdated(data);
      toast({ title: "Mensaje de seguimiento actualizado" });
    } catch (err) {
      toast({ title: "Error al guardar", description: formatApiErrorDetail(err.response?.data?.detail), variant: "destructive" });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-white border border-border rounded-xl p-6 sm:p-8 shadow-sm space-y-5">
      <div>
        <h2 className="font-serif text-xl text-foreground">Mensaje de seguimiento por WhatsApp</h2>
        <p className="text-sm text-muted-foreground mt-1">
          Se sugiere al contactar a una paciente desde el panel de Seguimiento. Usá {"{patient_name}"}, {"{service_name}"} y {"{clinic_name}"} como variables.
        </p>
      </div>
      <Textarea value={template} onChange={(e) => setTemplate(e.target.value)} rows={4} data-testid={CLINIC.followupTemplateInput} />
      <Button onClick={handleSave} disabled={saving} className="bg-brand hover:bg-brand-hover text-white" data-testid={CLINIC.followupTemplateSaveButton}>
        {saving ? "Guardando..." : "Guardar cambios"}
      </Button>
    </div>
  );
}
